import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { RemoveMembershipForm } from 'modules/components/layer12';
import { useParams } from 'react-router-dom';

export type RemoveMembershipModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveMembershipModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove Member'
      subTitle='Confirm you would like to remove this person from the project.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveMembershipForm.FC
        projectId={params.projectId ?? ''}
        personId={params.personId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
